import { render, staticRenderFns } from "./vuezhongjian.vue?vue&type=template&id=720f0af0&scoped=true"
import script from "./vuezhongjian.vue?vue&type=script&lang=js"
export * from "./vuezhongjian.vue?vue&type=script&lang=js"
import style0 from "./vuezhongjian.vue?vue&type=style&index=0&id=720f0af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f0af0",
  null
  
)

export default component.exports